<template>
    <modal :show.sync="value" :show-close="false" headerClasses="justify-content-center">
        <h4 slot="header" class="title title-up m-0">{{title}}</h4>
        <slot name="body"/>
        <template slot="footer">
            <p-button type="default" class="btn-outline-default btn-round mr-1" link @click="cancel">{{$t(cancelText)}}</p-button>
            <p-button type="success" class="btn-outline-success btn-round ml-1" link :disabled="disabled" @click="submit">{{$t(submitText)}}</p-button>
        </template>
    </modal>
</template>

<script>
  import { Modal, Button } from 'src/components/UIComponents'

  export default {
    name: 'BasicModal',

    components: {
      Modal,
      [Button.name]: Button
    },
    props: {
      value: {
        type: Boolean,
        required: true
      },
      title: {
        type: String,
        default: ''
      },
      submitText: {
        type: String,
        default: 'Add'
      },
      cancelText: {
        type: String,
        default: 'Cancel'
      },
      disabled: {
        type: Boolean,
        default: false
      },
      submit: {
        type: Function,
        default: () => {}
      },
      cancel: {
        type: Function,
        default: () => {}
      }
    }

  }
</script>